import index from '../../contentBlocks/components/embed.js';
export default index;